import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";

export const generateCertificatePDF = (application, officialName) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Add border
  doc.setLineWidth(1);
  doc.setDrawColor(6, 95, 70); // Emerald-800
  doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

  // Header - Government Seal
  doc.setFillColor(6, 95, 70);
  doc.circle(pageWidth / 2, 35, 15, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("GOVT", pageWidth / 2, 33, { align: "center" });
  doc.text("SEAL", pageWidth / 2, 39, { align: "center" });

  // Title
  doc.setTextColor(6, 95, 70);
  doc.setFontSize(24);
  doc.setFont("helvetica", "bold");
  doc.text("LAND RECORD CERTIFICATE", pageWidth / 2, 65, { align: "center" });

  // Subtitle
  doc.setTextColor(71, 85, 105);
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text("Revenue Department - Magadi Aadalat Portal", pageWidth / 2, 73, { align: "center" });

  // Certificate Number
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Certificate No: CERT-${application.land_survey_number}`, pageWidth / 2, 85, {
    align: "center",
  });

  // Divider line
  doc.setLineWidth(0.5);
  doc.setDrawColor(203, 213, 225);
  doc.line(30, 90, pageWidth - 30, 90);

  // Main Content
  let yPos = 105;
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0);

  const content = [
    "This is to certify that the following land record application has been",
    "verified, reviewed, and APPROVED by the Revenue Department.",
  ];

  content.forEach((line) => {
    doc.text(line, pageWidth / 2, yPos, { align: "center" });
    yPos += 7;
  });

  yPos += 5;

  // Application Details Table
  doc.autoTable({
    startY: yPos,
    head: [[{ content: "Application Details", colSpan: 2, styles: { halign: "center" } }]],
    body: [
      ["Survey Number", application.land_survey_number],
      ["Farmer Name", application.farmer_name],
      ["Email", application.farmer_email],
      ["Land Area", `${application.land_area} acres`],
      ["Location", application.location],
      ["Village", application.village],
      ["District", application.district],
      ["Purpose", application.purpose],
      ["Application Date", format(new Date(application.created_at), "MMMM dd, yyyy")],
      ["Approval Date", format(new Date(application.updated_at), "MMMM dd, yyyy")],
    ],
    theme: "grid",
    headStyles: {
      fillColor: [6, 95, 70],
      textColor: 255,
      fontSize: 12,
      fontStyle: "bold",
    },
    bodyStyles: {
      fontSize: 10,
    },
    alternateRowStyles: {
      fillColor: [245, 245, 244],
    },
    margin: { left: 30, right: 30 },
  });

  yPos = doc.lastAutoTable.finalY + 20;

  // Official Statement
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(71, 85, 105);
  doc.text(
    "This certificate is issued under the authority of the Revenue Department and",
    pageWidth / 2,
    yPos,
    { align: "center" }
  );
  doc.text(
    "is valid for all legal and official purposes.",
    pageWidth / 2,
    yPos + 6,
    { align: "center" }
  );

  // Signature Section
  yPos = pageHeight - 60;
  doc.setLineWidth(0.5);
  doc.setDrawColor(0, 0, 0);
  doc.line(130, yPos, 180, yPos);

  yPos += 5;
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Authorized Revenue Official", 155, yPos, { align: "center" });

  yPos += 5;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(officialName || "Revenue Department", 155, yPos, { align: "center" });

  // Footer
  yPos = pageHeight - 25;
  doc.setFontSize(8);
  doc.setTextColor(100, 116, 139);
  doc.text(
    "This is a digitally generated certificate from Magadi Aadalat Portal",
    pageWidth / 2,
    yPos,
    { align: "center" }
  );
  doc.text(
    `Generated on: ${format(new Date(), "MMMM dd, yyyy 'at' h:mm a")}`,
    pageWidth / 2,
    yPos + 5,
    { align: "center" }
  );

  // Watermark
  doc.setTextColor(6, 95, 70);
  doc.setFontSize(60);
  doc.setFont("helvetica", "bold");
  doc.saveGraphicsState();
  doc.setGState(new doc.GState({ opacity: 0.05 }));
  doc.text("APPROVED", pageWidth / 2, pageHeight / 2, {
    align: "center",
    angle: -45,
  });
  doc.restoreGraphicsState();

  return doc;
};

export const downloadCertificate = (application, officialName) => {
  const doc = generateCertificatePDF(application, officialName);
  doc.save(`Land-Certificate-${application.land_survey_number}.pdf`);
};